import React, { useEffect, useState } from 'react';
import PopupNotification from './PopupNotification';
import { Form, Button, DatePicker } from 'antd';
import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { setLoading } from '../store/feedback';
import moment from 'moment';
import dayjs from 'dayjs';
import './auditCreation.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './createAudit.css';
import {
  StyledInput,
  StyledSelect,
} from '../login-module/customComponents/styled_input';
import { useNavigate } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { v4 as uuidv4 } from 'uuid';

const calculateAge = (date) => {
  if (!date) return '';
  const d = dayjs(date);
  const now = dayjs();
  const years = now.diff(d, 'year');
  const months = now.diff(d.add(years, 'year'), 'month');
  return `${years} Year${years !== 1 ? 's' : ''} ${months} Month${months !== 1 ? 's' : ''}`;
};

const AuditDetails = (props) => {
  const theme = createTheme({
    components: {
      MuiInputBase: {
        styleOverrides: {
          root: {
            fontSize: '16px',
          },
        },
      },
    },
  });

  const [birthDate, setBirthDate] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [cattleCount, setCattleCount] = useState(1);
  const [caseDetails, setCaseDetails] = useState({});
  const [loading, setLoadingState] = useState(false);
  const [form] = Form.useForm();
  const [userId, setUserId] = useState(null);
  const [isFormValid, setIsFormValid] = useState(false);

  const generateRandomNDigitString = (n) => {
    const uuid = uuidv4().replace(/-/g, '');
    return uuid.substring(0, n).toUpperCase();
  };

  const generateRandomId = () => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let result = '';
    for (let i = 0; i < 4; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters[randomIndex];
    }
    const now = new Date();
    const day = now.getDate().toString().padStart(2, '0');
    const hours = now.getHours().toString().padStart(2, '0');
    const mins = now.getMinutes().toString().padStart(2, '0');
    const secs = now.getSeconds().toString().padStart(2, '0');
    const dateTimePart = day + hours + mins + secs;
    result += dateTimePart;
    return result.slice(0, 12);
  };

  useEffect(() => {
    const uuid = generateRandomNDigitString(10);
    setUserId(uuid);
  }, []);

  useEffect(() => {
    if (userId) {
      const cachedCompanies = localStorage.getItem('insuranceUser');
      const company = cachedCompanies ? JSON.parse(cachedCompanies).company : '';
      setCaseDetails({
        "User Id": userId,
        "Farmer's Name": '',
        "Aadhar No.": '',
        "Category": '',
        "Phone no.": '',
        // "Cattle Type": '',
        // "Animal Specification": '',
        // "Age in Year & Months": '',
        // "Milk Yield": '',
        "Vet's Name": '',
        "Vet's Email": '',
        "Vet Phone no": '',
        "Insurance Company": company,
        "No. of Cattles": 1,
      });
      // also set form initial values if needed
      form.setFieldsValue({
        "Insurance Company": company,
        "No. of Cattles": 1,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  const handleInputChange = (type, e) => {
    // supports being called with an event or direct value (defensive)
    const value = e && e.target !== undefined ? e.target.value : e;
    setCaseDetails((prevDetails) => ({
      ...prevDetails,
      [type]: value,
    }));
  };

  const handleSelectionChange = (type, value) => {
    form.setFieldsValue({ [type]: value });
    setCaseDetails((prevDetails) => ({
      ...prevDetails,
      [type]: value,
    }));
  };

  const handleDateChange = (date) => {
    // AntD DatePicker might give a moment; convert to dayjs for calculateAge
    const d = date ? dayjs(date) : null;
    setBirthDate(d);
    const age = calculateAge(d);
    // use generic setter (not event) so handleInputChange handles it
    setCaseDetails((prevDetails) => ({
      ...prevDetails,
      'Age in Year & Months': age,
    }));
  };

  const incrementCattle = () => {
    if (cattleCount < 10) {
      const newCount = cattleCount + 1;
      setCattleCount(newCount);
      setCaseDetails((prevDetails) => ({
        ...prevDetails,
        'No. of Cattles': newCount,
      }));
    }
  };

  const decrementCattle = () => {
    if (cattleCount > 1) {
      const newCount = cattleCount - 1;
      setCattleCount(newCount);
      setCaseDetails((prevDetails) => ({
        ...prevDetails,
        'No. of Cattles': newCount,
      }));
    }
  };

  const validateForm = () => {
    const requiredFields = [
      'Category',
      'Phone no.',
      // 'Cattle Type',
      // 'Animal Specification',
      // 'Age in Year & Months',
      // 'Milk Yield',
      "Vet's Name",
      "Vet's Email",
      "Vet Phone no",
      'Insurance Company',
      'No. of Cattles',
    ];

    // every required field must be present and not blank (special-case numeric count)
    const allPresent = requiredFields.every((field) => {
      const val = caseDetails[field];

      // if field is the numeric count
      if (field === 'No. of Cattles') {
        return typeof val === 'number' ? val > 0 : (val ?? '').toString().trim() !== '' && Number(val) > 0;
      }

      if (val === null || val === undefined) return false;
      // for objects or arrays, consider them valid if not empty
      if (typeof val === 'object') {
        try {
          return Object.keys(val).length > 0;
        } catch (e) {
          return !!val;
        }
      }
      return val.toString().trim() !== '';
    });

    return allPresent && cattleCount > 0;
  };
const generateRandom6DigitCode = () => {
  return Math.floor(100000 + Math.random() * 900000).toString();
};

  useEffect(() => {
    setIsFormValid(validateForm());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [caseDetails, cattleCount]);

  const insuranceUser = (() => {
    try {
      return JSON.parse(localStorage.getItem('insuranceUser'));
    } catch (e) {
      return null;
    }
  })();
  const user_Id = insuranceUser?.userId;
  const insuranceConfig = (() => {
    try {
      return JSON.parse(localStorage.getItem('inspectionConfig'));
    } catch (e) {
      return null;
    }
  })();

  const onFinish = async () => {
    const showPopup = (msg) => {
      setPopupMessage(msg);
      setPopupVisible(true);
    };

    // Check audit limit first
    try {
      const limitResponse = await axios.post('/create_audit/check_audit_limit', {
        userID: user_Id,
      });

      if (limitResponse.data.hasReachedLimit) {
        showPopup("You can't create audit now, you reached the limit");
        return;
      }
    } catch (error) {
      console.error('Error checking audit limit:', error);
      showPopup('Failed to verify audit limit. Please try again.');
      return;
    }

    // Validate Aadhar number (12 digits) if present
    const aadharNo = (caseDetails['Aadhar No.'] ?? '').toString().trim();
    if (aadharNo && (aadharNo.length !== 12 || !/^\d+$/.test(aadharNo))) {
      showPopup('Aadhar number must be exactly 12 digits');
      return;
    }

    // Validate Email
    const email = (caseDetails["Vet's Email"] ?? '').toString().trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      showPopup('Please enter a valid email address');
      return;
    }

    // Validate Phone number (10 digits)
    const phoneNo = (caseDetails['Phone no.'] ?? '').toString().trim();
    if (phoneNo.length !== 10 || !/^\d+$/.test(phoneNo)) {
      showPopup('Phone number must be exactly 10 digits');
      return;
    }

    const phoneNo2 = (caseDetails['Vet Phone no'] ?? '').toString().trim();
    if (phoneNo2.length !== 10 || !/^\d+$/.test(phoneNo2)) {
      showPopup("Vet's Phone number must be exactly 10 digits");
      return;
    }

    setLoadingState(true);
    dispatch(setLoading(true));

    const baseCaseId = generateRandomId();
    const configData = insuranceConfig?.inspection_config;
    const orgId = insuranceConfig?.org_id;

    try {
      // Generate all case IDs first
      const caseIds = [];
      for (let i = 1; i <= cattleCount; i++) {
        caseIds.push(`${baseCaseId}_${i}`);
      }

      // Call get_token API for each cattle with suffixed caseId
      const tokenPromises = caseIds.map((suffixedCaseId) =>
        axios.post('/create_audit/get_token', {
          auditID: suffixedCaseId,
          lead_creation_time: moment().format('DD-MM-YYYY HH:mm'),
          user_ID: user_Id,
          configData: configData,
          orgId: orgId,
        })
      );

      // Wait for all token API calls to complete
      await Promise.all(tokenPromises);

      // Make individual upload calls for each cattle to match backend expectations
      // const uploadPromises = caseIds.map((caseId, index) => {
      //   const blobName = `cattle_insuance_details/${caseId}.json`;
      //   const fileContent = btoa(
      //     JSON.stringify({
      //       ...caseDetails,
      //       'Cattle Index': index + 1,
      //       'Total Cattles': cattleCount,
      //       'Case Reference No.': caseId,
      //     })
      //   );
      //   const contentType = 'application/json';

      //   return axios.post('/process_data/upload-file-others', {
      //     blobName,
      //     fileContent,
      //     contentType,
      //     caseId,
      //   });
      // });
      const uploadPromises = caseIds.map((caseId, index) => {
        const CattleId = generateRandom6DigitCode(); // New field

        const blobName = `cattle_insuance_details/${caseId}.json`;
        const fileContent = btoa(
          JSON.stringify({
            ...caseDetails,
            'Cattle Index': index + 1,
            'Total Cattles': cattleCount,
            'Case Reference No.': caseId,
            'Cattle Id': CattleId, 
          })
        );
        const contentType = 'application/json';

        return axios.post('/process_data/upload-file-others', {
          blobName,
          fileContent,
          contentType,
          caseId,
        });
      });
      // Wait for all uploads to complete
      await Promise.all(uploadPromises);
      console.log('All uploads successful');
      navigate('/auditList');
      // navigate(`/audit/inspection/mode/${baseCaseId}`);
    } catch (err) {
      console.error('Submission error:', err);
      showPopup('Something went wrong while submitting. Please try again.');
    } finally {
      setLoadingState(false);
      dispatch(setLoading(false));
    }
  };


  return (
    <ThemeProvider theme={theme}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
        <style jsx>
          {`
            .input-lowercase::placeholder {
              text-transform: capitalize;
            }
          `}
        </style>

        <div
          className="responsive-form-container"
          style={{
            flex: 1,
            overflowY: 'auto',
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
          }}
        >
          {loading && (
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.3)',
                zIndex: 10,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <CircularProgress size={40} sx={{ color: '#FC350B' }} />
            </div>
          )}

          <PopupNotification visible={popupVisible} message={popupMessage} onClose={() => setPopupVisible(false)} />

          <div className="form-data">
            <div className="audit-details-group" style={{ width: '80vw' }}>
              {/* Category */}
              <div className="input-wrapper">
                <Form.Item name="Category" rules={[{ required: true, message: 'Please select Category' }]}>
                  <div style={{ position: 'relative' }}>
                    <StyledSelect
                      value={caseDetails['Category']}
                      style={{ width: 200 }}
                      onChange={(e) => handleSelectionChange('Category', e)}
                      options={[
                        { value: 'SC', label: 'SC' },
                        { value: 'ST', label: 'ST' },
                        { value: 'General', label: 'General' },
                        { value: 'OBC', label: 'OBC' },
                      ]}
                    />
                    <span className={caseDetails['Category'] ? 'fill' : 'unfilled'}>Category</span>
                  </div>
                </Form.Item>
              </div>

              {/* Phone no. */}
              <div className="input-wrapper">
                <Form.Item name="Phone no." rules={[{ required: true, message: 'Please enter Phone no.' }]}>
                  <div style={{ position: 'relative' }}>
                    <StyledInput
                      value={caseDetails['Phone no.']}
                      style={{ width: 200 }}
                      placeholder=" "
                      maxLength={10}
                      onChange={(e) => handleInputChange('Phone no.', e)}
                    />
                    <span className={caseDetails['Phone no.'] ? 'fill' : 'unfilled'}>Farmer Phone no.</span>
                  </div>
                </Form.Item>
              </div>

              {/* Cattle Type */}
              {/* /* <div className="input-wrapper">
                <Form.Item name="Cattle Type" rules={[{ required: true, message: 'Please enter Cattle Type' }]}>
                  <div style={{ position: 'relative' }}>
                    <StyledSelect
                      value={caseDetails['Cattle Type']}
                      style={{ width: 200 }}
                      placeholder=" "
                      onChange={(e) => handleSelectionChange('Cattle Type', e)}
                      options={[
                        { value: 'cow', label: 'Cow' },
                        { value: 'buffalo', label: 'Buffalo' },
                      ]}
                    />
                    <span className={caseDetails['Cattle Type'] ? 'fill' : 'unfilled'}>Cattle Type</span>
                  </div>
                </Form.Item>
              </div> */ }

              {/* Animal Specification */}
              {/* <div className="input-wrapper">
                <Form.Item
                  name="Animal Specification"
                  rules={[{ required: true, message: 'Please enter Animal Specification' }]}
                >
                  <div style={{ position: 'relative' }}>
                    <StyledSelect
                      value={caseDetails['Animal Specification']}
                      style={{ width: 200 }}
                      placeholder=" "
                      onChange={(e) => handleSelectionChange('Animal Specification', e)}
                      options={[
                        { value: 'HF', label: 'HF' },
                        { value: 'HF Cross', label: 'HF Cross' },
                        { value: 'Jersey', label: 'Jersey' },
                        { value: 'Jersey Cross', label: 'Jersey Cross' },
                        { value: 'Gir', label: 'Gir' },
                        { value: 'Gir Cross', label: 'Gir Cross' },
                        { value: 'Deoni', label: 'Deoni' },
                        { value: 'Local', label: 'Local' },
                        { value: 'Sahiwal Cross', label: 'Sahiwal Cross' },
                        { value: 'ND', label: 'ND' },
                        { value: 'Murrah', label: 'Murrah' },
                        { value: 'Nagpuri', label: 'Nagpuri' },
                        { value: 'Surti', label: 'Surti' },
                        { value: 'Pandharpuri', label: 'Pandharpuri' },
                        { value: 'Local ND', label: 'Local ND' },
                        { value: 'MR Cross', label: 'MR Cross' },
                        { value: 'Munner Cross', label: 'Munner Cross' },
                        { value: 'ND Cross', label: 'ND Cross' },
                        { value: 'Murrah Cross', label: 'Murrah Cross' },
                      ]}
                    />
                    <span className={caseDetails['Animal Specification'] ? 'fill' : 'unfilled'}>Animal Specification</span>
                  </div>
                </Form.Item>
              </div> */}

              {/* Age in Year & Months */}
              {/* <div className="input-wrapper">
                <Form.Item name="Age in Year & Months" rules={[{ required: true, message: 'Please enter Age' }]}>
                  <div style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 10, flexDirection: 'column' }}>
                    <DatePicker
                      className="ant-input"
                      style={{ width: '100%' }}
                      placeholder="Select Date of Birth"
                      format="DD-MM-YYYY"
                      value={birthDate}
                      onChange={handleDateChange}
                    />

                    {caseDetails['Age in Year & Months'] && (
                      <div style={{ marginTop: 4, color: '#555' }}>
                        Age: {caseDetails['Age in Year & Months']}
                      </div>
                    )}
                  </div>
                </Form.Item>
              </div> */}

              {/* Milk Yield */}
              {/* <div className="input-wrapper">
                <Form.Item name="Milk Yield" rules={[{ required: true, message: 'Please enter Milk Yield' }]}>
                  <div style={{ position: 'relative' }}>
                    <StyledInput
                      value={caseDetails['Milk Yield']}
                      style={{ width: 200 }}
                      placeholder=" "
                      onChange={(e) => handleInputChange('Milk Yield', e)}
                    />
                    <span className={caseDetails['Milk Yield'] ? 'fill' : 'unfilled'}>Milk Yield</span>
                  </div>
                </Form.Item>
              </div> */}

              {/* Vet's Name */}
              <div className="input-wrapper">
                <Form.Item name="Vet's Name" rules={[{ required: true, message: "Please enter Vet's Name" }]}>
                  <div style={{ position: 'relative' }}>
                    <StyledInput
                      value={caseDetails["Vet's Name"]}
                      style={{ width: 200 }}
                      placeholder=" "
                      onChange={(e) => handleInputChange("Vet's Name", e)}
                    />
                    <span className={caseDetails["Vet's Name"] ? 'fill' : 'unfilled'}>Vet's Name</span>
                  </div>
                </Form.Item>
              </div>

              {/* Vet's Email */}
              <div className="input-wrapper">
                <Form.Item
                  name="Vet's Email"
                  rules={[
                    { required: true, message: "Please enter Vet's Email" },
                    { type: 'email', message: 'Please enter a valid email' },
                  ]}
                >
                  <div style={{ position: 'relative' }}>
                    <StyledInput
                      value={caseDetails["Vet's Email"]}
                      style={{ width: 200 }}
                      placeholder=" "
                      onChange={(e) => handleInputChange("Vet's Email", e)}
                    />
                    <span className={caseDetails["Vet's Email"] ? 'fill' : 'unfilled'}>Vet's Email</span>
                  </div>
                </Form.Item>
              </div>

              {/* Vet Phone no */}
              <div className="input-wrapper">
                <Form.Item name="Vet Phone no" rules={[{ required: true, message: 'Please enter Phone no.' }]}>
                  <div style={{ position: 'relative' }}>
                    <StyledInput
                      value={caseDetails['Vet Phone no']}
                      style={{ width: 200 }}
                      placeholder=" "
                      maxLength={10}
                      onChange={(e) => handleInputChange('Vet Phone no', e)}
                    />
                    <span className={caseDetails['Vet Phone no'] ? 'fill' : 'unfilled'}>Vet Phone no</span>
                  </div>
                </Form.Item>
              </div>

              {/* Insurance Company */}
              <div className="input-wrapper">
                <Form.Item name="Insurance Company" style={{ position: 'relative' }} rules={[{ required: true, message: 'Insurance company is required' }]}>
                  <div style={{ position: 'relative' }}>
                    <StyledSelect
                      value={caseDetails['Insurance Company']}
                      style={{ width: 200 }}
                      placeholder=" "
                      onChange={(e) => handleSelectionChange('Insurance Company', e)}
                      options={[{ value: 'nandi', label: 'Nandi' }]}
                    />
                    <span className={caseDetails['Insurance Company'] ? 'fill' : 'unfilled'}>Insurance Company</span>
                  </div>
                </Form.Item>
              </div>

              {/* No. of Cattles */}
              <div className="input-wrapper">
                <Form.Item name="No. of Cattles" rules={[{ required: true, message: 'Please enter No. of Cattles' }]}>
                  <div style={{ position: 'relative' }}>
                    <div className="cattle-field" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                      <button
                        type="button"
                        onClick={decrementCattle}
                        className="counter-btn"
                        disabled={cattleCount <= 1}
                        style={{ width: 34, height: 34 }}
                      >
                        −
                      </button>
                      <span className="counter-value" style={{ minWidth: 36, textAlign: 'center' }}>
                        {cattleCount.toString().padStart(2, '0')}
                      </span>
                      <button
                        type="button"
                        onClick={incrementCattle}
                        className="counter-btn plus"
                        disabled={cattleCount >= 10}
                        style={{ width: 34, height: 34 }}
                      >
                        +
                      </button>
                    </div>
                  </div>
                </Form.Item>
              </div>
            </div>

            <div
              style={{
                position: 'sticky',
                bottom: 30,
                padding: '16px',
                textAlign: 'center',
              }}
            >
              <Form.Item style={{ margin: '0px' }}>
                <Button
                  style={{
                    backgroundColor: isFormValid ? '#FC350B' : 'gray',
                    color: '#FFFFFF',
                    minHeight: '40px',
                    width: '300px',
                    borderRadius: '2px',
                  }}
                  htmlType="button"
                  className="responsive-button"
                  disabled={!isFormValid}
                  onClick={onFinish}
                >
                  Proceed to choose inspection method
                </Button>
              </Form.Item>
            </div>
          </div>
        </div>

        <ToastContainer />
      </div>
    </ThemeProvider>
  );
};

export default AuditDetails;
